import { render, staticRenderFns } from "./monitoring.vue?vue&type=template&id=064581f9&scoped=true"
import script from "./monitoring.vue?vue&type=script&lang=js"
export * from "./monitoring.vue?vue&type=script&lang=js"
import style0 from "./monitoring.vue?vue&type=style&index=0&id=064581f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064581f9",
  null
  
)

export default component.exports